import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'falsy',
})
export class FalsyPipe implements PipeTransform {
  transform<T>(value: T, falsyValue = '---'): T | string {
    return value || falsyValue;
  }
}
